import {
    DATA_TYPE,
    COMMUNICATION_FORMAT,
    DATA_FORMAT,
    DOMAIN_MAX_LENGTH,
} from "../../constants";

export const attachmentSchema = {
    "documentAttachment": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "name": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.NAME,
            value: "",
        },
        "documentId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "workspaceId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "createdDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "updatedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        }
    }
} as const;
